import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import ContainerCard from "components/ContainerCard";
import Container from "@mui/material/Container";
import ChatFlowInfo from "./sections/ChatFlowInfo";
import AgentInstructionButtons from "./sections/AgentInstructionButtons";
import KnowledgeBaseOverview from "./sections/KnowledgeBaseOverview";
import { KnowledgeBaseOverviewProvider } from "./contexts/KnowledgeBaseOverviewContext";
import Breadcrumbs from "examples/Breadcrumbs";
import ChatTokenLength from "./sections/ChatTokenLength";

function AgentsOverview() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />

      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[{ label: "Admin", route: "/admin" }, { label: "Chatbot Logica" }]}
          />
          <ChatFlowInfo />
          <AgentInstructionButtons />
          <KnowledgeBaseOverviewProvider>
            <KnowledgeBaseOverview />
          </KnowledgeBaseOverviewProvider>
          <ChatTokenLength />
        </Container>
      </ContainerCard>
    </>
  );
}

export default AgentsOverview;
